import { useCallback, useState } from 'react'

type Id = string | number

export function useMultiSelect<T extends Id = Id>(initialValue: T[] = []) {
	const [selected, setSelected] = useState<T[]>(initialValue)

	const toggle = useCallback((id: T | 'all') => {
		if (id === 'all') {
			setSelected([])
			return
		}

		setSelected(prev =>
			prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id],
		)
	}, [])

	const remove = useCallback((id: T) => {
		setSelected(prev => prev.filter(item => item !== id))
	}, [])

	const reset = useCallback(() => {
		setSelected([])
	}, [])

	return {
		selected,
		setSelected,
		toggle,
		remove,
		reset,
	}
}
